export const Skyscraper = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg
    width="141"
    height="141"
    viewBox="0 0 141 141"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M71.2033 47.9263H29.7676V115.571H71.2033V47.9263Z" fill="#C3C4C5" />
    <path d="M67.2853 53.1843H33.6855V58.9632H67.2853V53.1843Z" fill="#F2F4F5" />
    <path d="M67.2853 61.6787H33.6855V67.4576H67.2853V61.6787Z" fill="#F2F4F5" />
    <path d="M67.2853 70.1741H33.6855V75.9529H67.2853V70.1741Z" fill="#F2F4F5" />
    <path d="M67.2853 78.6699H33.6855V84.4488H67.2853V78.6699Z" fill="#F2F4F5" />
    <path d="M67.2853 87.1653H33.6855V92.9441H67.2853V87.1653Z" fill="#F2F4F5" />
    <path d="M67.2853 95.6609H33.6855V101.44H67.2853V95.6609Z" fill="#F2F4F5" />
    <path d="M67.2853 53.1843H33.6855V58.9632H67.2853V53.1843Z" fill="#F2F4F5" />
    <path d="M67.2853 61.6787H33.6855V67.4576H67.2853V61.6787Z" fill="#F2F4F5" />
    <path d="M67.2853 70.1741H33.6855V75.9529H67.2853V70.1741Z" fill="#F2F4F5" />
    <path d="M67.2853 78.6699H33.6855V84.4488H67.2853V78.6699Z" fill="#F2F4F5" />
    <path d="M67.2853 87.1653H33.6855V92.9441H67.2853V87.1653Z" fill="#F2F4F5" />
    <path d="M67.2853 95.6609H33.6855V101.44H67.2853V95.6609Z" fill="#F2F4F5" />
    <path d="M39.4644 103.854H33.6855V109.633H39.4644V103.854Z" fill="#F2F4F5" />
    <path d="M47.3785 103.854H41.5996V109.633H47.3785V103.854Z" fill="#F2F4F5" />
    <path d="M55.2925 103.854H49.5137V109.633H55.2925V103.854Z" fill="#F2F4F5" />
    <path d="M62.9585 103.854H57.1797V109.633H62.9585V103.854Z" fill="#D8DFE0" />
    <path d="M72.7049 101.44V95.6609H54.5498L53.3184 101.44H72.7049Z" fill="#D8DFE0" />
    <path d="M58.1689 78.6699L56.9375 84.4488H72.7042V78.6699H58.1689Z" fill="#D8DFE0" />
    <path d="M56.3584 87.1653L55.127 92.9441H72.7041V87.1653H56.3584Z" fill="#D8DFE0" />
    <path d="M55.293 109.633V103.854H52.8037L51.5723 109.633H55.293Z" fill="#D8DFE0" />
    <path d="M63.6078 53.1416L62.3672 58.9633H72.7047V53.1416H63.6078Z" fill="#D8DFE0" />
    <path d="M61.79 61.6787L60.5586 67.4586H72.7055V61.6787H61.79Z" fill="#D8DFE0" />
    <path d="M59.9795 70.1741L58.748 75.954H72.7054V70.1741H59.9795Z" fill="#D8DFE0" />
    <path d="M132.395 114.9H7.14844V118.837H132.395V114.9Z" fill="#C3C4C5" />
    <path d="M106.345 29.8619H61.5059V115.571H106.345V29.8619Z" fill="#C3C4C5" />
    <path d="M102.426 36.193H65.4219V41.9718H102.426V36.193Z" fill="#F2F4F5" />
    <path d="M102.426 44.6888H65.4219V50.4677H102.426V44.6888Z" fill="#F2F4F5" />
    <path d="M102.426 53.1842H65.4219V58.9631H102.426V53.1842Z" fill="#F2F4F5" />
    <path d="M102.426 61.6786H65.4219V67.4574H102.426V61.6786Z" fill="#F2F4F5" />
    <path d="M102.426 70.174H65.4219V75.9528H102.426V70.174Z" fill="#F2F4F5" />
    <path d="M102.426 78.6696H65.4219V84.4484H102.426V78.6696Z" fill="#F2F4F5" />
    <path d="M102.426 87.1652H65.4219V92.944H102.426V87.1652Z" fill="#F2F4F5" />
    <path d="M102.426 95.6608H65.4219V101.44H102.426V95.6608Z" fill="#F2F4F5" />
    <path d="M71.2007 103.854H65.4219V109.633H71.2007V103.854Z" fill="#F2F4F5" />
    <path d="M102.427 103.854H96.6484V109.633H102.427V103.854Z" fill="#D8DFE0" />
    <path d="M93.3056 103.854H74.5449V115.571H93.3056V103.854Z" fill="#F2F4F5" />
    <path d="M89.0906 70.2169L87.8867 75.9366H102.428V70.2169H89.0906Z" fill="#D8DFE0" />
    <path d="M102.428 101.439V95.7451H83.7202L82.5234 101.439H102.428Z" fill="#D8DFE0" />
    <path d="M87.2965 78.7379L86.0957 84.4485H102.427V78.7379H87.2965Z" fill="#D8DFE0" />
    <path d="M102.428 41.8872V36.193H96.2456L95.0488 41.8872H102.428Z" fill="#D8DFE0" />
    <path d="M85.5064 87.2509L84.3086 92.9441H102.427V87.2509H85.5064Z" fill="#D8DFE0" />
    <path d="M90.8673 61.7643L89.6797 67.4157H102.428V61.7643H90.8673Z" fill="#D8DFE0" />
    <path d="M74.5449 103.854V115.571H79.5511L82.0159 103.854H74.5449Z" fill="#F2F4F5" />
    <path d="M93.3063 103.854H82.0156L79.5508 115.571H93.3063V103.854Z" fill="#D8DFE0" />
    <path d="M94.4589 44.6888L93.252 50.4249H102.427V44.6888H94.4589Z" fill="#D8DFE0" />
    <path d="M92.664 53.2272L91.457 58.9632H102.429V53.2272H92.664Z" fill="#D8DFE0" />
    <path
      d="M44.2472 31.0567C44.2483 30.9873 44.2574 30.9201 44.2574 30.8507C44.2574 25.5918 39.9944 21.3287 34.7354 21.3287C29.9759 21.3287 26.0442 24.8242 25.3378 29.3859C25.296 29.3859 25.2552 29.3798 25.2134 29.3798C19.9544 29.3798 15.6914 33.6428 15.6914 38.9018H51.6795C51.072 34.9894 48.0893 31.865 44.2472 31.0567Z"
      fill="white"
    />
  </svg>
);
